module.exports = __webpack_public_path__ + "img/beauty-services-calendar-black.7c2f728.svg";